import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=925cb4aa&scoped=true&"
import script from "./CertificatePage.vue?vue&type=script&lang=js&"
export * from "./CertificatePage.vue?vue&type=script&lang=js&"
import style0 from "./CertificatePage.vue?vue&type=style&index=0&id=925cb4aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925cb4aa",
  null
  
)

export default component.exports